import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/shared/edCompleteFeatures";
import { BillingCycleType } from "../Subscription/types";
import { BillingCycle } from "../Subscription/constants";

const I18n = I18nUtil.createScoped(Translations);

export interface EdCompleteFeatureRow {
  key: string;
  label: string;
  freeValue: boolean;
  completeValue: boolean;
}

export const getFreeFeatures = (): string[] => [
  I18n.t("Account connections"),
  I18n.t("Daily Brief · 5/day"),
  I18n.t("Money Scan · 3 actions"),
  I18n.t("Plan tab · demo"),
  I18n.t("Desk · 2 notes"),
];

export const getCompleteFeatures = (payCycle?: BillingCycleType): string[] => {
  if (payCycle === BillingCycle.LIFETIME) {
    return [
      I18n.t("Ed Complete · For life"),
      I18n.t("Locked-in pricing"),
      I18n.t("Founding Ambassador badge"),
      I18n.t("Private beta access"),
    ];
  }
  return [
    I18n.t("Your full Money Plan"),
    I18n.t("Investment + Planning · Unlimited"),
    I18n.t("Cross-domain reasoning"),
    I18n.t("Daily Money Brief"),
    I18n.t("Desk · unlimited notes"),
    I18n.t("Private Financial Vault"),
  ];
};

export const getFeatureComparisonRows = (): EdCompleteFeatureRow[] => [
  {
    key: "connections",
    label: I18n.t("Account connections"),
    freeValue: true,
    completeValue: true,
  },
  {
    key: "money_scan",
    label: I18n.t("Money Scan"),
    freeValue: true,
    completeValue: true,
  },
  {
    key: "daily_brief",
    label: I18n.t("Daily Money Brief"),
    freeValue: true,
    completeValue: true,
  },
  {
    key: "desk_notes",
    label: I18n.t("Desk notes"),
    freeValue: true,
    completeValue: true,
  },
  {
    key: "money_plan",
    label: I18n.t("Your full Money Plan"),
    freeValue: false,
    completeValue: true,
  },
  {
    key: "invest_plan",
    label: I18n.t("Invest & Plan, unlimited"),
    freeValue: false,
    completeValue: true,
  },
  {
    key: "cross_domain",
    label: I18n.t("Cross-domain reasoning"),
    freeValue: false,
    completeValue: true,
  },
  {
    key: "vault",
    label: I18n.t("Private Financial Vault"),
    freeValue: false,
    completeValue: true,
  },
];

export const getLifetimeExclusiveRows = (): EdCompleteFeatureRow[] => [
  {
    key: "locked_pricing",
    label: I18n.t("Locked-in pricing"),
    freeValue: false,
    completeValue: true,
  },
  {
    key: "ambassador_badge",
    label: I18n.t("Founding Ambassador badge"),
    freeValue: false,
    completeValue: true,
  },
  {
    key: "beta_access",
    label: I18n.t("Private beta access"),
    freeValue: false,
    completeValue: true,
  },
];
